module.exports = __webpack_public_path__ + "media/highclass/example-1-2f5dd77c.webp";